function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#f0f0f0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.22 6.67a4 4 0 00-5.55 1.11c-.07.12-.12.24-.19.36A2 2 0 0010 10a2 2 0 013.33 2.22 4 4 0 00-1.11-5.55z",
  fill: "#c60c30"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": 10,
  d: "M6.67 7.78A2 2 0 0010 10a2 2 0 013.33 2.22 4 4 0 01-6.66-4.44",
  fill: "#003478"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.93 5.757L5.76 2.93l1.414 1.414L4.345 7.17zM12.831 15.657l2.829-2.828 1.414 1.414-2.829 2.828zM14.243 2.93l2.829 2.83-1.415 1.413-2.828-2.828zM4.343 12.83l2.828 2.83-1.414 1.413-2.829-2.828z"
});

function SvgKr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjBmMGYwO30uY2xzLTJ7ZmlsbDojYzYwYzMwO30uY2xzLTN7ZmlsbDojMDAzNDc4O308L3N0eWxlPjwvZGVmcz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTIuMjIsNi42N0E0LDQsMCwwLDAsNi42Nyw3Ljc4Yy0uMDcuMTItLjEyLjI0LS4xOS4zNkEyLDIsMCwwLDAsMTAsMTBhMiwyLDAsMCwxLDMuMzMsMi4yMkE0LDQsMCwwLDAsMTIuMjIsNi42N1oiLz48cGF0aCBpZD0iXzEwIiBkYXRhLW5hbWU9IjEwIiBjbGFzcz0iY2xzLTMiIGQ9Ik02LjY3LDcuNzhBMiwyLDAsMCwwLDEwLDEwYTIsMiwwLDAsMSwzLjMzLDIuMjJBNCw0LDAsMCwxLDYuNjcsNy43OCIvPjxyZWN0IHg9IjMuMDUiIHk9IjQuMDUiIHdpZHRoPSI0IiBoZWlnaHQ9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yLjA5IDUuMDUpIHJvdGF0ZSgtNDUpIi8+PHJlY3QgeD0iMTIuOTUiIHk9IjEzLjk1IiB3aWR0aD0iNCIgaGVpZ2h0PSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNi4xOSAxNC45NSkgcm90YXRlKC00NSkiLz48cmVjdCB4PSIxMi45NSIgeT0iNC4wNSIgd2lkdGg9IjQiIGhlaWdodD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy45NSAtOS4wOSkgcm90YXRlKDQ1KSIvPjxyZWN0IHg9IjMuMDUiIHk9IjEzLjk1IiB3aWR0aD0iNCIgaGVpZ2h0PSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMi4wNSAwLjgxKSByb3RhdGUoNDUpIi8+PC9zdmc+";
export { SvgKr as ReactComponent };